import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createTagAppRequest = { tagApps: '_tagApp' };
var _createTagAppResponse = { failedApps: '_tagApp' };
var _deleteTagAppRequest = {};
var _deleteTagAppResponse = {};
var _getAppsByTagRequest = {};
var _getAppsByTagResponse = { tagApps: '_tagApp' };
var _getTagAppRequest = {};
var _getTagAppResponse = { tagApp: '_tagApp' };
var _queryTagAppRequest = {};
var _queryTagAppResponse = { tagApps: '_tagApp' };
var _reorderManualPositionRequest = {};
var _reorderManualPositionResponse = { tagApps: '_tagApp' };
var _tagApp = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
function resolveWixDevcenterAppmarketV1TagAppsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/tags-apps',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/tags-apps',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/tags-apps',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/tags-apps',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new TagApp */
export function createTagApp(payload) {
    var _a = serializer(_createTagAppRequest, { _tagApp: _tagApp }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTagAppResponse, { _tagApp: _tagApp }).fromJSON;
    function __createTagApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.appmarket.v1.tag_app',
            method: 'POST',
            methodFqn: 'wix.devcenter.appmarket.v1.TagApps.CreateTagApp',
            url: resolveWixDevcenterAppmarketV1TagAppsUrl({
                protoPath: '/v1/tagApps',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTagApp.fromReq = fromReq;
    __createTagApp.__isAmbassador = true;
    return __createTagApp;
}
/** Creates a new TagApp */
export function reOrder(payload) {
    var _a = serializer(_reorderManualPositionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reorderManualPositionResponse, {
        _tagApp: _tagApp,
    }).fromJSON;
    function __reOrder(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.appmarket.v1.tag_app',
            method: 'POST',
            methodFqn: 'wix.devcenter.appmarket.v1.TagApps.ReOrder',
            url: resolveWixDevcenterAppmarketV1TagAppsUrl({
                protoPath: '/v1/tagApps/reorder',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reOrder.fromReq = fromReq;
    __reOrder.__isAmbassador = true;
    return __reOrder;
}
/** Get a TagApp by id */
export function getTagApp(payload) {
    var _a = serializer(_getTagAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTagAppResponse, { _tagApp: _tagApp }).fromJSON;
    function __getTagApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.appmarket.v1.tag_app',
            method: 'GET',
            methodFqn: 'wix.devcenter.appmarket.v1.TagApps.GetTagApp',
            url: resolveWixDevcenterAppmarketV1TagAppsUrl({
                protoPath: '/v1/tagApp/{tagAppId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTagApp.fromReq = fromReq;
    __getTagApp.__isAmbassador = true;
    return __getTagApp;
}
/** Get a TagApp by id */
export function getAppsByTag(payload) {
    var _a = serializer(_getAppsByTagRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getAppsByTagResponse, { _tagApp: _tagApp }).fromJSON;
    function __getAppsByTag(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.appmarket.v1.tag_app',
            method: 'POST',
            methodFqn: 'wix.devcenter.appmarket.v1.TagApps.GetAppsByTag',
            url: resolveWixDevcenterAppmarketV1TagAppsUrl({
                protoPath: '/v1/apps-by-tag',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getAppsByTag.fromReq = fromReq;
    __getAppsByTag.__isAmbassador = true;
    return __getAppsByTag;
}
/** Delete a TagApp */
export function deleteTagApp(payload) {
    var _a = serializer(_deleteTagAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTagAppResponse, {}).fromJSON;
    function __deleteTagApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.appmarket.v1.tag_app',
            method: 'DELETE',
            methodFqn: 'wix.devcenter.appmarket.v1.TagApps.DeleteTagApp',
            url: resolveWixDevcenterAppmarketV1TagAppsUrl({
                protoPath: '/v1/tagApps/{tagAppIds}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTagApp.fromReq = fromReq;
    __deleteTagApp.__isAmbassador = true;
    return __deleteTagApp;
}
/** Query TagApps using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryTagApp(payload) {
    var _a = serializer(_queryTagAppRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTagAppResponse, { _tagApp: _tagApp }).fromJSON;
    function __queryTagApp(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.devcenter.appmarket.v1.tag_app',
            method: 'POST',
            methodFqn: 'wix.devcenter.appmarket.v1.TagApps.QueryTagApp',
            url: resolveWixDevcenterAppmarketV1TagAppsUrl({
                protoPath: '/v1/tagApps/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTagApp.fromReq = fromReq;
    __queryTagApp.__isAmbassador = true;
    return __queryTagApp;
}
//# sourceMappingURL=http.impl.js.map